import React from "react";
import PropTypes from "prop-types";

import { Flex, Text } from "shipnow-mercurio";

const DEFAULT_PROPS = {
  buttonComponent: null,
  textProps: {
    size: "pageTitle",
    padding: "t-8",
  },
  padding: "t-8",
};

export const SectionHeader = (props) => {
  const attrs = {
    ...DEFAULT_PROPS,
    ...props,
    textProps: {
      ...DEFAULT_PROPS.textProps,
      ...props.textProps,
    },
  };

  const { textProps } = attrs;

  return (
    <Flex padding={attrs.padding} justifyContent="space-between">
      <Text {...textProps} />

      {!!attrs.buttonComponent && <attrs.buttonComponent />}
    </Flex>
  );
};

SectionHeader.propTypes = {
  buttonComponent: PropTypes.func,
  textProps: PropTypes.shape({
    size: PropTypes.string,
    padding: PropTypes.string,
    children: PropTypes.node,
  }),
  padding: PropTypes.string,
};
